/* eslint-disable */

import React from "react";
import Modal from "react-bootstrap/Modal";
import APIClient from "../client";
import { Tab, Tabs } from "react-bootstrap";
import Jobs from "./Jobs";
import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { interpolate } from "../../shared/utils/legacy";
import Tractors from "./Tractors";

class LinkTrimble extends React.Component {
  state = {
    showModal: false,
    account: null,
    organization: null,
    showWarning: false,
  };

  constructor(props, context) {
    super(props, context);
    this.loadAccount();
  }

  componentDidMount() {
    cropr.updateTrimbleState = () => {
      this.loadAccount();
    };
  }
  componentWillUnmount() {
    delete cropr.updateTrimbleState;
  }

  loadAccount = () => {
    fetch("/apps/cloudfarm/get_tractors/T/")
      .then((response) => {
        if (response.status === 401) {
          cropr.notify(
            "danger",
            interpolate(gettext("Your %s authorization seems to be no longer valid."), ["Trimble"])
          );
        }
        if (response.ok) {
          response.json().then((account) => {
            this.setState({
              account: account,
              organization: account.selected_org,
              showWarning: false,
            });
          });
        } else {
          throw { status: response.status };
        }
      })
      .catch((error) => {
        this.setState({
          account: null,
          organization: null,
        });
      });
  };

  authorizeAccount() {
    fetch("/apps/cloudfarm/tr_authorization_url/")
      .then(function (response) {
        if (response.ok) {
          return response.json();
        } else {
          cropr.notify("danger", gettext("Your account could not be linked at this time."));
          throw { status: response.status };
        }
      })
      .then((json) => {
        window.open(json.tr_authorization_url, "_blank");
        this.setState({ showWarning: true });
      })
      .catch((error) => console.error("Error:", error));
  }

  async changeOrganization(orgId) {
    const formData = new FormData();
    formData.append("organization_id", orgId);
    try {
      await APIClient.post(
        "/api/data/trimble/set_org/",
        { formData: formData },
        cropr.cloudfarm_oauth_token
      ).then((response) => {
        cropr.notify("success", gettext("De organization has been set."));
        this.loadAccount();
      });
    } catch {
      cropr.notify("danger", gettext("De organization could not be linked at this time."));
    }
  }

  async removeAccount() {
    try {
      await APIClient.remove(
        "/api/data/trimble/delete_tr_credentials",
        null,
        cropr.cloudfarm_oauth_token
      ).then((response) => {
        cropr.notify("success", gettext("Your account has been deleted successfully."));
        this.loadAccount();
      });
    } catch {
      cropr.notify("danger", gettext("Your account could not be deleted at this time."));
    }
  }

  toggle(show) {
    this.setState({ showModal: show });
  }

  render() {
    return (
      <>
        <a href="#" className="dropdown-item" onClick={() => this.toggle(true)}>
          {interpolate(gettext("Connect with %s"), ["Trimble"])}
        </a>
        <Modal show={this.state.showModal} onHide={() => this.toggle(false)}>
          <Modal.Header closeButton>
            <Modal.Title style={{ width: "100%" }}>
              Trimble account
              <img
                className="float-right"
                src="/static/img/trimble.png"
                alt="Trimble"
                style={{ height: "30px" }}
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tabs defaultActiveKey={this.state.organization ? "tractors" : "account"}>
              <Tab eventKey="account" title={gettext("Account")}>
                {this.state.showWarning ? (
                  <div className="alert alert-info">
                    {gettext("Be sure to allow this page to open popup windows in your browser.")}
                  </div>
                ) : null}
                {this.state.account ? (
                  <div>
                    <h4 className="mt-2">
                      {gettext("Currently linked account")}: {this.state.account.username}
                    </h4>
                    {this.state.account.organizations.length === 0 && (
                      <div className="alert alert-info">
                        {gettext("Please authorize access to one or more organizations.")}
                      </div>
                    )}
                    <div className="mt-2">
                      <span className="align-middle">{gettext("Organization: ")}</span>
                      <select
                        id="jd-org-select"
                        className="custom-select custom-select-sm ml-2 w-50"
                        style={{ background: "none" }}
                        defaultValue={this.state.organization || ""}
                        onChange={(e) => this.changeOrganization(e.target.value)}
                      >
                        {!this.state.organization ? (
                          <option key="-" value="">
                            {"--" + gettext("Choose") + "--"}
                          </option>
                        ) : null}
                        {this.state.account.organizations.map((org) => (
                          <option value={String(org.id)} key={org.id}>
                            {org.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mt-4">
                      <a
                        className="btn btn-info mr-1"
                        href={
                          this.state.account.select_orgs_url +
                          "&redirectionUrl=" +
                          document.location.href
                        }
                      >
                        {gettext("Authorize access to organizations")}
                      </a>
                      <a className="btn btn-warning mr-1" onClick={() => this.removeAccount()}>
                        {gettext("Delete")}
                      </a>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="mt-4">
                      <a className="btn btn-primary" onClick={() => this.authorizeAccount()}>
                        {gettext("Authorize")}
                      </a>
                    </div>
                  </div>
                )}
              </Tab>
              <Tab eventKey="tractors" title={gettext("Tractors")} disabled={!this.state.account}>
                {this.state.organization ? (
                  <Tractors
                    accountName={this.state.account.username}
                    headers={[
                      gettext("Name") + " (Tr)",
                      gettext("Name") + " (Dacom)",
                      gettext("Serial number"),
                      gettext("Type"),
                    ]}
                    tractors={this.state.account.tractors.map((t, i) => ({
                      display: [
                        t.name,
                        cropr.machines.findWhere({ endpoint_id: String(t.iD) })?.get("name") || "-",
                        t.serialNumber,
                        t.deviceType,
                      ],
                      serialNr: t.id,
                      receiveOnly: true,
                    }))}
                    noActions={true}
                  />
                ) : null}
              </Tab>
              <Tab eventKey="tasks" title={gettext("Tasks")} disabled={!this.state.account}>
                {this.state.account ? <Jobs online_service="T" /> : null}
              </Tab>
              <Tab eventKey="help" title={gettext("Help")}>
                <h5 className="mt-2">{gettext("What is a connection to Trimble Ag?")}</h5>
                {interpolate(
                  gettext(
                    "If you possess equipment that is connected to %s, you can authorize Cloudfarm to exchange data with this platform. Please talk to your dealer for more information about this system."
                  ),
                  ["Trimble Ag"]
                )}
                <h5 className="mt-2">{gettext("What can I do with it?")}</h5>
                {gettext(
                  "You can exchange task data directly between your vehicle and The Dacom platform/ Cloudfarm:"
                )}
                <ul>
                  <li>
                    {gettext(
                      'After connecting, your vehicle(s) will be present under the "Machines" menu. There, you can rename your vehicle, and attach a default recording template.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'You can can create prescription maps in the "Recording" menu. If you select a connected vehicle under "Machines", this prescription map will be automatically transmitted to your vehicle.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'After completing a task on the vehicle, the "as applied" data is automatically loaded in Cloudfarm, where you can review the work done.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      ' If you use the vehicle to record field boundaries and way lines, you can easily import them into your Dacom farm by clicking "details" in the dataset card and go to the "geometry" tab. This way you can easily reuse this data for other vehicles, for instance by converting them into a different format with the "export machine data" functionality. '
                    )}
                  </li>
                </ul>
              </Tab>
            </Tabs>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default LinkTrimble;
